// Component: RelatedContent
// Author: Vijay Radhakrishnan
import * as React from 'react';
import RelatedContentNPM from '@rotaryintl/component-related-content';
import WBRString from '@component/WbrString';
import { RoutableLink } from '../../react/RoutableLink';
import EditableLink from '../../react/EditableLink';
import { Text, Link, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import i18n from 'i18next';
import Divider from '@rotaryintl/component-divider';

const RelatedContent = (props) => {
  const getRelatedTerm = () => {
    return i18n.t('term/related') || 'Related';
  };

  const links = [];

  const isEditing = props.sitecoreContext && props.sitecoreContext.pageEditing;

  props.fields?.children?.forEach((link, index) => {
    let l = (
      <>
        <RoutableLink field={link.fields.RelatedContentLink} key={index} useATag={true}>
          <WBRString tag="span">
            <Text field={link.fields.RelatedContentLinkText} />
          </WBRString>
        </RoutableLink>
        <EditableLink linkField={link.fields.RelatedContentLink} isEditing={isEditing} />
      </>
    );

    links.push(l);
  });

  var RelatedContentData = {
    title: getRelatedTerm(),
    links: links,
  };

  return (
    <>
      <div style={{ marginBottom: '30px' }}>
        <Divider color="gray" thickness="thin" />
      </div>
      <RelatedContentNPM {...RelatedContentData} />
    </>
  );
};

export default withSitecoreContext()(RelatedContent);
